import { observer } from "mobx-react-lite";
import { applyTextFieldStyle, EXTERNAL_API_FORM_REQUIRED_LABEL, useExternalAPIWizardStore, WIDTH_SPACE, CLIENT_ID, CLIENT_SECRET, GRANT_TYPE, SCOPE, TOKEN_URL } from "./ExternalAPIWizardStore";
import { useLocale } from "designSystem/locale";
import { FlexColumn, TextField, Text, FormControlLabel } from "designSystem/index";
import React from "react";

export const OAuth2TypeSetupForm = observer(() => {
	const locale = useLocale();
	const store = useExternalAPIWizardStore();
	const {
		clientID,
		clientIDError, 
		clientIDErrorHelperTextRes, 
		clientSecret,
		clientSecretError,
		clientSecretErrorHelperTextRes, 
		isClientSecretHidden,
		scope,
		tokenURL,
		tokenURLError, 
		tokenURLErrorHelperTextRes, 
		hideClientSecret,
		setClientID,
		setClientSecret,
		setScope,
		setTokenURL,
		showClientSecret,
		isReadonlyField,
	} = store;

	return (
		<FlexColumn width="100%">
			<FormControlLabel
				control={(
					<TextField
						autoFocus
						defaultValue={clientID}
						disabled={isReadonlyField(CLIENT_ID)}
						error={clientIDError}
						helperTextRes={clientIDErrorHelperTextRes}
						onChange={setClientID}
						placeholder={locale.resource("OAuth2CredentialClientIdFieldPlaceholder")}
						sx={applyTextFieldStyle("75%")}
					/>
				)}
				label={<Text bold text={locale.attributeResource("OAuth2Credentials", "ClientId")} />}
				labelPlacement="start"
				required
				sx={{ ...EXTERNAL_API_FORM_REQUIRED_LABEL, ...WIDTH_SPACE }}
			/>
			<FormControlLabel
				control={(
					<TextField
						disabled={isReadonlyField(CLIENT_SECRET)}
						error={clientSecretError}
						fullWidth
						helperTextRes={clientSecretErrorHelperTextRes}
						onBlur={hideClientSecret}
						onChange={setClientSecret}
						onFocus={showClientSecret}
						placeholder={locale.resource("OAuth2CredentialClientSecretFieldPlaceholder")}
						sx={applyTextFieldStyle("75%")}
						value={isClientSecretHidden ? "\u{2022}".repeat(200) : clientSecret}
					/>
				)}
				label={<Text bold text={locale.attributeResource("OAuth2Credentials", "ClientSecret")} />}
				labelPlacement="start"
				required
				sx={{ ...EXTERNAL_API_FORM_REQUIRED_LABEL, ...WIDTH_SPACE }}
			/>
			<FormControlLabel
				control={(
					<TextField
						defaultValue={tokenURL}
						disabled={isReadonlyField(TOKEN_URL)}
						error={tokenURLError}
						helperTextRes={tokenURLErrorHelperTextRes}
						onChange={setTokenURL}
						placeholder={locale.resource("OAuth2CredentialTokenURLFieldPlaceholder")}
						sx={applyTextFieldStyle("75%")}
					/>
				)}
				label={<Text bold text={locale.resource("TokenURL")} />}
				labelPlacement="start"
				required
				sx={{ ...EXTERNAL_API_FORM_REQUIRED_LABEL, ...WIDTH_SPACE }}
			/>
			<FormControlLabel
				control={(
					<TextField
						defaultValue={scope}
						disabled={isReadonlyField(SCOPE)}
						onChange={setScope}
						sx={applyTextFieldStyle("75%")}
					/>
				)}
				label={<Text bold text={locale.attributeResource("OAuth2Credentials", "Scope")} />}
				labelPlacement="start"
				sx={WIDTH_SPACE}
			/>
			<FormControlLabel
				control={(
					<TextField
						disabled={isReadonlyField(GRANT_TYPE)}
						placeholder="Client Credentials"
						sx={applyTextFieldStyle("75%")}
					/>
				)}
				label={<Text bold text={locale.resource("GrantType")} />}
				labelPlacement="start"
				sx={WIDTH_SPACE}
			/>
		</FlexColumn>
	);
});
